import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { task } from 'ember-concurrency';
import EmObject, { action } from '@ember/object';
import ENV from 'cio/config/environment';
import isValidEmail from 'cio/utils/validators/email';
import FormValidations from 'cio/utils/form-validations';
import ApiService from 'cio/services/api';
import AlertsService from 'cio/services/alerts';
import RouterService from '@ember/routing/router-service';

const Validations = {
  email(value: string) {
    if (!isValidEmail(value)) {
      return 'Please enter a valid email address';
    }

    return true;
  },
};

export default class IndexController extends Controller {
  @service api!: ApiService;
  @service alerts!: AlertsService;
  @service router!: RouterService;

  _validations: FormValidations;
  _formValues = EmObject.create({ email: '' });
  _emailInputTouched = false;

  constructor() {
    super(...arguments);

    this._validations = FormValidations.create({ validations: Validations, context: this, modelKey: '_formValues' });
  }

  _submitTask = task(async (evt: Event) => {
    evt.preventDefault();

    try {
      await this._validations.validateModel();
    } catch (e) {
      // `validateModel` already found and set validation errors
      // return early to avoid executing real submit logic
      return;
    }

    try {
      await this.api.post('reset_password_by_email', {
        pathScope: 'global',
        ignoreErrors: true,
        data: { email: this._formValues.email },
      });

      this.alerts.success(
        'resetPassword.success',
        'If user with this e-mail address exists, you will receive an email with instructions about how to reset your password in a few minutes.',
        undefined,
        ENV.APP.alertDurationLong,
      );
      this.router.transitionTo('login');
    } catch (e) {
      this.alerts.error('resetPassword.error', 'Problem requesting reset password instructions. Try again later.');
    }
  });

  setDefaultProperties() {
    this.setProperties({
      _formValues: EmObject.create({
        email: '',
      }),
      _emailInputTouched: false,
    });
  }

  @action
  onEmailBlur() {
    this.set('_emailInputTouched', this._emailInputTouched || Boolean(this._formValues.email));
  }

  @action
  onEmailInput(value: string) {
    this._formValues.set('email', value);
    this._validations.validateAttribute('email');
  }
}
